import React, { useEffect, useState } from "react";
import api from "~/services/api";
import { LandPage, Container, Main } from './styles';
import CustomBodyContent from "./CustomBodyContent";
import { Colors } from "~/config/Colors";
import { useSelector } from "react-redux";

export default function DashboardProjeto() {
  const [data, setData] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const { perfil } = useSelector(state => state.auth);
  const [anos, setAnos] = useState([]);
  const [anoAtivo, setAnoAtivo] = useState(new Date().getFullYear());
  const [clientes, setClientes] = useState([]);
  const [clienteFiltro, setClienteFiltro] = useState([]);

  useEffect(() => {
    setLoadedData(false);
  }, [perfil]);


  useEffect(() => {
    async function handleRequests() {
      api.get('/signed/geral/acessos/check')
        .then(response => setModulos(response.data));

      api.get("/signed/empresa/gestorprojeto/cliente/clientes", { params: { ativo: 1 } })
        .then(response => setClientes(response.data));

      setAnos([
        { id: new Date().getFullYear() - 2 },
        { id: new Date().getFullYear() - 1 },
        { id: new Date().getFullYear() },
      ])
    }

    handleRequests();
  }, []);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            requests={{
              findAll: () =>
                api.get(
                  '/signed/empresa/gestorprojeto/relatorios/relatorioprojetos',
                  { params: { idCliente: clienteFiltro, ano: anoAtivo } },
                ),
            }}
            setter={setData}
            setLoaded={setLoadedData}
            loaded={loadedData}
            informationPage={{
              title: 'Dashboard',
              subTitle: "Filtre e gere o relatório que precisar",
              icone: 'submenu-dashboard',
            }}
          >
            <CustomBodyContent {...{ data }} />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
